import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { FamilyDatas, ResponseAnprData } from 'shell/models/person';
import { AnprVM } from 'shell/view-models/search-anpr';
import { CohabitationVM } from 'cohabitation/view-models/list-cohabitation';

export const transformMembers = (
  httpResponse: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<CohabitationVM> & { datiFamigliaConvivenza?: FamilyDatas } => {
  const data = httpResponse.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];
  const datiFamigliaConvivenza = httpResponse.data.payload?.risposta3002OK?.datiFamigliaConvivenza;
  const familyMembers: Array<CohabitationVM> = data.map((item) => {
    // Residence check for object
    let residence = '';

    const residenza = item.residenza || [];
    // scelgo il primo o è un array?
    if (residenza[0]?.indirizzo) {
      residence = `${residenza[0]?.indirizzo?.toponimo?.specie || ''} ${
        residenza[0]?.indirizzo?.toponimo?.denominazioneToponimo || ''
      }, ${residenza[0]?.indirizzo?.numeroCivico?.numero || ''} ${
        residenza[0]?.indirizzo?.numeroCivico?.esponente1 ||
        residenza[0]?.indirizzo?.numeroCivico?.lettera
          ? `/${residenza[0]?.indirizzo?.numeroCivico?.esponente1 || ''}${
              residenza[0]?.indirizzo?.numeroCivico?.lettera || ''
            }`
          : ''
      }`;
    }

    return {
      idCardMunicipality:
        item.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenza || '',
      codeIstat:
        item.famigliaConvivenza?.idFamigliaConvivenzaComune?.idFamigliaConvivenzaComuneIstat || '',
      idANPR: item.famigliaConvivenza?.idFamigliaConvivenzaANPR || '',
      nameCohabitation: item.famigliaConvivenza?.denominazioneConvivenza || '',
      address: residence,
      parenthood: item.legameSoggetto?.descrizioneCodiceLegame || '',
    };
  });

  return {
    warnings: (httpResponse.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (httpResponse.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: familyMembers[0] ? [familyMembers[0]] : [],
    datiFamigliaConvivenza,
  };
};
